'use es6';

import { getType } from '../../common-message-format/operators/commonMessageFormatGetters';
import { PRESENTATIONAL_MESSAGE_TYPES } from '../constants/messageTypeGroups';
export function isPresentationalMessage(message) {
  const type = getType(message);
  return PRESENTATIONAL_MESSAGE_TYPES.includes(type);
}